import { z } from 'zod'

/**
 * Parâmetros de URL compartilhados entre `/`, `/cadastro` e retorno Google (next / return_app).
 */
export const loginRedirectSearchSchema = z.object({
  /** Definido pelo app principal após logout — força limpeza de tokens neste host. */
  signed_out: z.literal('1').optional(),
  /** Sessão encerrada porque houve login em outro dispositivo/navegador. */
  session_ended: z.literal('superseded').optional(),
  error: z.string().optional(),
  next: z.string().optional(),
  return_app: z.enum(['suporte', 'admindesk']).optional(),
})

export type LoginRedirectSearch = z.infer<typeof loginRedirectSearchSchema>
